module.exports = __webpack_public_path__ + "media/images/rolls-royce-vector-logo-302769be10ccd644f618e45005588e73.svg";